<template>
  <v-menu
    :ref="`intervalDatesMenu_${scopeKey}`"
    v-model="intervalDatesMenu"
    :close-on-content-click="false"
    :return-value.sync="selectedDate"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="IntervalDatesFormatted"
        :label="$t('fields.interval')"
        readonly
        outlined
        prepend-inner-icon="mdi-calendar"
        dense
        hide-details
        style="max-width: 400px"
        class="my-1"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      range
      first-day-of-week="1"
      color="primary"
      scrollable
    >
      <v-btn
        text
        width="145px"
        color="error"
        @click="intervalDatesMenu = false"
      >
        {{ $t('buttons.back') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        text
        width="145px"
        color="success"
        :disabled="selectedDate.length !== 2"
        @click="saveCreatedAtFilter"
      >
        {{ $t('buttons.save') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'DateIntervalPicker',
  props: {
    scope: {
      required: true,
      type: String,
    },
    scopeKey: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      intervalDatesMenu: false,
    }
  },
  computed: {
    IntervalDatesFormatted() {
      if (this.selectedDate) {
        return this.selectedDate.map((date) =>
          this.$options.filters.formatDate(date)
        )
      }

      return ''
    },
    selectedDate: {
      get() {
        return this.$store.state.query.queryParams[this.scope][
          `filter[${this.scopeKey}]`
        ]
      },
      set(val) {
        this.setFilter({
          key: `filter[${this.scopeKey}]`,
          scope: this.scope,
          val,
        })

        if (
          this.$store.state.query.queryParams[this.scope][
            `filter[${this.scopeKey}]`
          ].length === 2
        ) {
          this.getData(this.scope)
        }
      },
    },
  },
  methods: {
    ...mapActions('resources', ['getData']),
    ...mapMutations('query', ['setFilter']),
    saveCreatedAtFilter() {
      this.$refs[`intervalDatesMenu_${this.scopeKey}`].save(this.selectedDate)
    },
  },
}
</script>
